import { Roles } from 'utils/enums';

export const ReportingRoles = [
  'Dashboard Viewer',
  'All Reports Viewer',
  'Explorer',
] as const;
export type ReportingRole = (typeof ReportingRoles)[number];

export const DataEntryRoles = [
  'Patient Registrar',
  'Read Only',
  'Other Data Entry',
] as const;
export type DataEntryRole = (typeof DataEntryRoles)[number];

export type UserFormValues = {
  name: string;
  email: string;
  nickname?: string | null;
  phoneNumber?: string | null;
  title?: string | null;
  credentials?: string | null;
  burnCenterId: number | null;
  active: boolean;
  canAccessVerification: boolean;
  canAccessBedEntry: boolean;
  canUpdateTrainingContent: boolean;
  role: (typeof Roles)[keyof typeof Roles] | null;
  reportingRole?: ReportingRole | null;
  clinicalStudioRole?: DataEntryRole | null;
  enableDataEntry?: boolean;
  enableReporting?: boolean;
};
